import React from 'react'
import { translate } from 'react-i18next'

const NewsCategoryListItem = ({t, item}) => (
	<li className="mb-2">
		<a className="news-card-body__headline" style={{fontSize: "20px", fontWeight: "normal"}} href={'/news/categories/' + item.seoPath + '?catId=' + item.id}>{item.name}</a>
	</li>
)
export default translate("translations")(NewsCategoryListItem)